'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = void 0;

var _jsxRuntime = require('react/jsx-runtime');

var _propTypes = _interopRequireDefault(require('prop-types'));

var _styles = require('@material-ui/core/styles');

var _colors = require('@material-ui/core/colors');

var _core = require('@material-ui/core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var StatusChip = (0, _styles.withTheme)(function (_ref) {
  var text = _ref.text,
    color = _ref.color,
    className = _ref.className,
    theme = _ref.theme;
  return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Box, {
    display: 'inline-flex',
    borderRadius: theme.shape.borderRadius,
    className: className,
    color: _colors.common.white,
    bgcolor: color,
    textAlign: 'center',
    alignItems: 'center',
    height: theme.spacing(3),
    width: theme.spacing(12),
    justifyContent: 'center',
    fontSize: '0.75rem',
    fontWeight: 'bold',
    children: text,
  });
});
StatusChip.propTypes = {
  text: _propTypes.default.string.isRequired,
  color: _propTypes.default.string,
};
var _default = StatusChip;
exports.default = _default;

//# sourceMappingURL=index.js.map
